__turbopack_context__.v({
  "addAction": "EditableTimeline-module__Pumv7a__addAction",
  "addBtn": "EditableTimeline-module__Pumv7a__addBtn",
  "addBtnList": "EditableTimeline-module__Pumv7a__addBtnList",
  "deleteBtn": "EditableTimeline-module__Pumv7a__deleteBtn",
  "displayRow": "EditableTimeline-module__Pumv7a__displayRow",
  "editBtn": "EditableTimeline-module__Pumv7a__editBtn",
  "editModeContainer": "EditableTimeline-module__Pumv7a__editModeContainer",
  "formActions": "EditableTimeline-module__Pumv7a__formActions",
  "globalActions": "EditableTimeline-module__Pumv7a__globalActions",
  "itemActionsHover": "EditableTimeline-module__Pumv7a__itemActionsHover",
  "placeholder": "EditableTimeline-module__Pumv7a__placeholder",
  "root": "EditableTimeline-module__Pumv7a__root",
  "textInputWrapper": "EditableTimeline-module__Pumv7a__textInputWrapper",
  "timeInputWrapper": "EditableTimeline-module__Pumv7a__timeInputWrapper",
  "timelineItem": "EditableTimeline-module__Pumv7a__timelineItem",
  "timelineItemContent": "EditableTimeline-module__Pumv7a__timelineItemContent",
  "timelineItemDisplay": "EditableTimeline-module__Pumv7a__timelineItemDisplay",
  "timelineItemDisplayRow": "EditableTimeline-module__Pumv7a__timelineItemDisplayRow",
  "timelineList": "EditableTimeline-module__Pumv7a__timelineList",
  "timelineText": "EditableTimeline-module__Pumv7a__timelineText",
  "timelineTime": "EditableTimeline-module__Pumv7a__timelineTime",
});
